import * as _ from "lodash";
import React, { useState, useEffect } from "react";

import * as Const from "../../../Constants";
import { pushTo } from "../../../Helpers/links";
import * as Models from "../../../Models";
import { OutotecIcons } from "../../General/Icons/";
import SearchSuggestion from "../../General/SearchSuggestion";
import { history } from "../../..";
import { parse } from "query-string";
import { fetchSearchSuggestions } from "../../../Api/azure";
import filterItemsStore from "../../../Store/filterItems";

interface SearchState {
    value: string;
    filter: string;
    submitted: boolean;
}

interface SearchProps {
    match: Models.Match;
    location: Models.Location;
    isModalSelectionMode: boolean;
}

export default function Search(props: SearchProps) {
    const [value, setValue] = useState<string>("");
    const [filter, setFilter] = useState<string>("");
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [selectedValue, setselectedValue] = useState<string>("");

    const { isModalSelectionMode, match } = props;
    const clearSearchIds = filterItemsStore((s) => s.clearSearchIds);
    const doSearch = filterItemsStore((s) => s.doSearch);

    useEffect(() => {
        setFilter(match?.params?.filter || "");
    }, [match?.params?.filter]);

    useEffect(() => {
        selectedValue && invokeSearch(selectedValue);
    }, [filter, selectedValue]);

    function getSuggestions(
        searchTerm: string
    ): Promise<Models.ISearchSuggestionResponse[]> {
        return fetchSearchSuggestions(searchTerm);
    }

    function invokeSearch(value: string): void {
        let filterValue: string = filter.toLowerCase();
        if (
            filterValue === Const.LOCATIONS_TREE ||
            filterValue === Const.BUILDS_TREE
        ) {
            filterValue = Const.SITE_TREE;
        }

        if (!props.isModalSelectionMode) {
            const queryParams: any = { search: value };
            pushTo({ filterValue, queryParams });
        }

        doSearch(value, filter, match.params, false, isModalSelectionMode);
    }

    const url: Models.IbUrl = parse(history.location.search);
    const searchTerm: string = url.search ? url.search : "";
    let searchValue: string = value;
    const searchClearClassName: string =
        ((searchTerm !== "" || (isModalSelectionMode && searchValue !== "")) &&
            "Search__clearer Search__clearer--active") ||
        "Search__clearer";

    if (!searchValue && searchTerm && !isModalSelectionMode) {
        searchValue = searchTerm;
    }

    function handleChange(value: string): void {
        if (value.length <= 0) {
            handleClear();
        } else {
            setValue(value);
        }
    }

    function handleSelect(value: string, filter: string): void {
        setFilter(filter);
        setselectedValue(value);
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        setSubmitted(true);
        setselectedValue(value);

        setTimeout(() => {
            setSubmitted(false);
        }, 1000);
    }

    function handleClear(): void {
        setValue("");
        if (!isModalSelectionMode) {
            pushTo(match.params);
            (document.querySelector("#SearchInputField") as any).value = "";
        }
        clearSearchIds();
    }

    return (
        <div className="Search">
            <div className="Search__container">
                <form onSubmit={(e) => handleSubmit(e)}>
                    <SearchSuggestion
                        value={searchValue}
                        inputProps={{
                            id: "SearchInputField",
                            type: "search",
                            className: "Search__textInput form-control",
                        }}
                        formSubmitFlagged={submitted}
                        fetchSuggestions={(value) => getSuggestions(value)}
                        onChange={(value) => handleChange(value)}
                        onSelect={(value, filter) =>
                            handleSelect(value, filter)
                        }
                    />

                    <span
                        className="Search__button"
                        aria-hidden="true"
                        id="btnGroupAddon"
                        onClick={() => invokeSearch(value)}
                    >
                        <OutotecIcons type={Const.SEARCH} />
                    </span>

                    <span
                        className={searchClearClassName}
                        onClick={() => handleClear()}
                    >
                        <OutotecIcons type={Const.CLOSE} />
                    </span>
                </form>
            </div>
        </div>
    );
}
